import React from 'react';
const TestimonialHeader = (props:any) => {
    
  return (
    <div className="testimonials-background">
      <div className="container">
        <h1 className="testimonials-h1">{props.data.title}</h1>
      </div>
    </div>
  );
};

export default TestimonialHeader;
